export default __webpack_public_path__ + "4a54620d6a87ff579285a0a0b5d54176.svg";